import { closest } from "@/utils/index"
import { pushAnalyticsObjToDataLayer } from "@/utils/helper"
import { INSPIRATION_PAGE_NAME } from "@/constants/index"

const getComponentZone = element => {
  const container = closest(element, el => el.className === "cmp-container")
  const zoneName = container?.getAttribute("id")
  if (zoneName) {
    if (
      zoneName === "color-material-finish" ||
      zoneName === "colors-materials-finishes"
    ) {
      return "colors-materials-finishes"
    }
    return zoneName.toLowerCase().replaceAll("-", " ")
  } else {
    return ""
  }
}

const getSubMenuValue = (baseValue, isSupportPage, panelTitle) => {
  if (baseValue) {
    return baseValue
  }
  if (isSupportPage) {
    return "submenu"
  }
  return panelTitle || "submenu navigation link"
}

export const getEventInfo = (
  eventName = "",
  componentLinkType = "",
  eventAction = "",
  eventPageType = "",
  item = {}
) => {
  const panelTitle = item["cq:panelTitle"]?.toLowerCase() || ""
  const isSupportPage = eventPageType.includes("support")
  const tabContainer = document?.querySelectorAll(".tabs")
  const isPageInspiration =
    eventPageType === INSPIRATION_PAGE_NAME.KIPS_BAY_DECORATOR
  let zoneVal

  tabContainer?.forEach(tabs => {
    if (!tabs?.classList?.contains("gbh-global-tab")) {
      zoneVal = getComponentZone(tabs?.parentElement)
    }
  })

  const subMenuValue = getSubMenuValue(eventName, isSupportPage, panelTitle)
  const subMenuAction = getSubMenuValue(eventAction, isSupportPage, panelTitle)
  const eventText = isPageInspiration
    ? `${eventPageType}:sub menu`
    : `${eventPageType}:${zoneVal}:sub menu`

  return {
    clickInternalLinks: "true",
    internalLinkPosition: `${eventPageType}:tab`,
    internalLinkZoneName: eventText,
    internalLinkURL: "n/a",
    internalLinkName: `${panelTitle}`,
    eventName: `${eventText}:${subMenuValue}`,
    internalLinkType: `${eventPageType}:${componentLinkType || "navigation"}`,
    eventType: "tab",
    eventAction: `${eventText}:${subMenuAction}`,
    eventMsg: "n/a",
    eventStatus: "n/a",
  }
}

export const handleTabClickDatalayer = (
  eventName = "",
  componentLinkType = "",
  eventAction = "",
  eventPageType = "",
  item = {}
) => {
  const eventInfo = getEventInfo(
    eventName,
    componentLinkType,
    eventAction,
    eventPageType,
    item
  )
  pushAnalyticsObjToDataLayer(eventInfo)
}
